import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { listSubscription, cancelSubscription } from "../api";
import getTeamApiCall from "components/shared/utils/getTeamApiCall";
import ChargebeeIframe from "components/ChargebeeIframe";
import { setIsLoading } from "redux/loader/action";
import { setCurrentUser } from "redux/game/action";

const UpdatePlans = ({
  history,
  currentUser,
  paymentDetails,
  onUpdatePaymentMethod,
  cancelPlanNotification
}) => {
  const dispatch = useDispatch();
  const teamId = currentUser?.team?.id;
  const noDetails =
    paymentDetails.list || currentUser?.team?.AnnualPlanState != null;
  const AnnualPlanState = currentUser?.team?.AnnualPlanState;
  const [chargebeeUrl, setChargebeeUrl] = useState("");

  const handleBtnClick = () => {
    if (noDetails) {
      history.push("/pricing_page");
    } else {
      onUpdatePaymentMethod();
    }
  };

  const handleCancelSubscription = async () => {
    dispatch(setIsLoading(true));

    let listPayload = { team_code: teamId };
    if (AnnualPlanState != null) {
      listPayload.state = "non_renewing";
    }
    const paymentDetailsRes = await listSubscription(listPayload);

    const cancelSubscriptionRes = await cancelSubscription({
      promocode: teamId,
      subscription_id: paymentDetailsRes.id,
      plan: paymentDetailsRes.subscription_items[0].item_price_id
    });
    if (
      cancelSubscriptionRes.subscription.status === "cancelled" ||
      cancelSubscriptionRes.subscription.status === "non_renewing"
    ) {
      const team = await getTeamApiCall(teamId, false);
      if (team?.AnnualPlanState != null)
        localStorage.setItem("annualNotification", "true");
      else {
      }
      localStorage.removeItem("annualNotification");
      cancelPlanNotification();

      dispatch(
        setCurrentUser({
          ...currentUser,
          plan_name: null,
          team: team || {}
        })
      );
    }
    dispatch(setIsLoading(false));
  };

  return (
    <section className="update-plans">
      <h2 className="heading">
        {noDetails ? "Explore Team Plans" : "Update Payment Method"}
      </h2>
      <p className="info">
        {noDetails
          ? `Plans are prices per employee. No hidden fees. Explore the right plan
            for your team to bring your team together and promote team culture!`
          : `Need to update your payment method or contact details? 
            Note: One active payment method is required.`}
      </p>
      <button className="view-all" onClick={handleBtnClick}>
        {noDetails ? "View All Plans" : "Update Payment"}
      </button>
      {!noDetails && (
        <button className="cancel-plan" onClick={handleCancelSubscription}>
          Cancel Plan
        </button>
      )}
      {chargebeeUrl !== "" && (
        <ChargebeeIframe
          url={chargebeeUrl}
          onCLose={() => setChargebeeUrl("")}
        />
      )}
    </section>
  );
};

export default UpdatePlans;
